import { ONLINE_METALS, STOCK_TYPES } from 'constants/all';

import { types } from './actions';

const initialState = {
  activeTab: STOCK_TYPES.RECTANGULAR,
  initialMaterialId: undefined,
  isFetchingMaterialAvailability: false,
  isInitializing: false,
  isVisualizing: false,
  materialAvailability: {
    onlineMetals: {
      bar: true,
      rod: true,
      sheet: true,
    },
  },
  partFilePacket: null,
  partFileStatuses: {},
  partFileUuid: null,
  partUuid: null,
  previousCADViewerKeys: {
    visible: null,
    focused: null,
  },
  provider: ONLINE_METALS,
  selectedMaterialId: null,
  stockInterrogatingList: [],
  successfullyVisualizedKeys: [],
  visualizedResultKey: null,
};

const reducer = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case types.AVAILABILITY_CHECK_START:
      return {
        ...state,
        isFetchingMaterialAvailability: true,
      };
    case types.AVAILABILITY_CHECK_FINISH:
      return {
        ...state,
        isFetchingMaterialAvailability: false,
        materialAvailability: {
          ...payload.materialAvailability,
        },
      };
    case types.MATERIAL_WIDGET_INIT_REQUEST:
      return {
        ...state,
        initialMaterialId: payload.materialId,
        isInitializing: true,
        partFilePacket: null,
        partFileUuid: payload.partFileUuid,
        partUuid: payload.partUuid,
        provider: payload.provider,
        visualizedResultKey: null,
      };
    case types.MATERIAL_WIDGET_RECEIVE_PART_FILE_PACKET:
      return {
        ...state,
        partFilePacket: payload.partFilePacket,
      };
    case types.MATERIAL_WIDGET_INIT_ERROR:
    case types.MATERIAL_WIDGET_INIT_SUCCESS:
      return {
        ...state,
        isInitializing: false,
      };
    case types.MATERIAL_WIDGET_RECEIVE_SELECTED_MATERIAL_ID:
      return {
        ...state,
        selectedMaterialId: payload.materialId,
      };
    case types.MATERIAL_WIDGET_RESET:
      return {
        ...initialState,
      };
    case types.MATERIAL_WIDGET_SET_PROVIDER:
      return {
        ...state,
        provider: payload.provider,
      };
    case types.RECEIVE_NEW_VISUALIZE_SUCCESS_KEY:
      return {
        ...state,
        successfullyVisualizedKeys: state.successfullyVisualizedKeys.concat([
          payload.resultKey,
        ]),
      };
    case types.RECEIVE_PREVIOUS_CADVIEWER_KEYS:
      return {
        ...state,
        previousCADViewerKeys: payload.previousCADViewerKeys,
      };
    case types.RECEIVE_STATUSES: {
      const nextStatuses = { ...state.partFileStatuses };
      for (const key in payload.partFileStatuses) {
        nextStatuses[key] = payload.partFileStatuses[key];
      }
      return {
        ...state,
        partFileStatuses: nextStatuses,
      };
    }
    case types.RECEIVE_VISUALIZED_KEY:
      return {
        ...state,
        visualizedResultKey: payload.resultKey,
      };
    case types.SET_ACTIVE_TAB:
      return {
        ...state,
        activeTab: payload.activeTab,
      };
    case types.STOCK_INTERROGATING_LIST_ADD:
      return {
        ...state,
        stockInterrogatingList: state.stockInterrogatingList.concat([
          payload.uuid,
        ]),
      };
    case types.STOCK_INTERROGATING_LIST_REMOVE:
      return {
        ...state,
        stockInterrogatingList: state.stockInterrogatingList.filter(
          (uuid) => uuid !== payload.uuid,
        ),
      };
    case types.VISUALIZE_SHOW_REQUEST:
      return {
        ...state,
        isVisualizing: true,
      };
    case types.VISUALIZE_SHOW_ERROR:
    case types.VISUALIZE_SHOW_SUCCESS:
      return {
        ...state,
        isVisualizing: false,
      };
    default:
      return state;
  }
};

const getScope = (state) =>
  state.modules.common.forms.materialWidget.materialWidget;

export const getIsFetchingMaterialAvailability = (state) =>
  getScope(state).isFetchingMaterialAvailability;

export const getIsInitializing = (state) => getScope(state).isInitializing;

export const getIsVisualizing = (state) => getScope(state).isVisualizing;

export const getMaterialAvailability = (state) =>
  getScope(state).materialAvailability[getScope(state).provider];

export const getPartFilePacket = (state) => getScope(state).partFilePacket;

export const getPartFileStatuses = (state) => getScope(state).partFileStatuses;

export const getPartFileUuid = (state) => getScope(state).partFileUuid;

export const getPartFileStatus = (state, uuid) => {
  const statuses = getPartFileStatuses(state);
  return statuses[uuid] || {};
};

export const getActivePartFileStatus = (state) => {
  const activeUuid = getPartFileUuid(state);
  return getPartFileStatus(state, activeUuid);
};

export const getPreviousCADViewerKeys = (state) =>
  getScope(state).previousCADViewerKeys;

export const getSelectedMaterialId = (state) =>
  getScope(state).selectedMaterialId;

export const getStockInterrogatingList = (state) =>
  getScope(state).stockInterrogatingList;

export const getSuccessfullyVisualizedKeys = (state) =>
  getScope(state).successfullyVisualizedKeys;

export const getVisualizedResultKey = (state) =>
  getScope(state).visualizedResultKey;

export const getInitialMaterialId = (state) =>
  getScope(state).initialMaterialId;

export const getProvider = (state) => getScope(state).provider;

export const getPartUuid = (state) => getScope(state).partUuid;

export default reducer;
